import './App.css';

function ContactUs() {
  return (
      <div className="contentDiv">
        <h1 className="contentHeader">Contact Us</h1>
        <ul className="contentSubHeader">
            <li>Instagram:  <a href="https://www.instagram.com/lobo.powerlifting">instagram.com/lobo.powerlifting</a>.</li>
            <li>Email: <a href="mailto:lobopowerlifting@clubs.unm.edu">lobopowerlifting@clubs.unm.edu</a>.</li>
        </ul>
      </div>
  );
}

export default ContactUs;
